import { render } from "./selectPorPag.vue?vue&type=template&id=1e9bd93d&scoped=true"
import script from "./selectPorPag.vue?vue&type=script&lang=js"
export * from "./selectPorPag.vue?vue&type=script&lang=js"

import "./selectPorPag.vue?vue&type=style&index=0&id=1e9bd93d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9bd93d"]])

export default __exports__